(() => {
  const technicalLabel = /^(Technische Daten|Technische Angaben)(?:\s+[^:]*)?:?$/i;
  const stopLabel = /^(Hinweis|Wichtig|Lieferumfang|Verpackungseinheit|Kompatibilität|Downloads?)\s*:?/i;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function moveTechnicalData(root = document) {
    const dataBlock = root.querySelector('accordeon-component.block-hg_product_data');
    const descriptionBlock = root.querySelector(
      'accordeon-component[data-product-block^="description"], accordeon-component.block-hg_product_description'
    );

    if (!dataBlock || !descriptionBlock || dataBlock.dataset.hgTechnicalMoved === 'true') return;

    const source = descriptionBlock.querySelector('[data-accordeon-content] .rte');
    const target = dataBlock.querySelector('[data-accordeon-content] .rte');

    if (!source || !target) return;

    const technicalContent = document.createElement('div');
    technicalContent.className = 'hg-product-data__technical';
    let moved = false;

    const legacySections = Array.from(source.querySelectorAll("div[class^='tab-'], div[class*=' tab-']")).filter((section) =>
      Array.from(section.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong')).some((element) =>
        technicalLabel.test(normalize(element.textContent))
      )
    );

    legacySections.forEach((section) => {
      technicalContent.append(section);
      moved = true;
    });

    Array.from(source.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach((heading) => {
      if (!heading.isConnected || !technicalLabel.test(normalize(heading.textContent))) return;

      const level = Number(heading.tagName.slice(1));
      let node = heading;

      while (node) {
        const next = node.nextElementSibling;

        if (node !== heading && /^H[1-6]$/.test(node.tagName)) {
          const nextLevel = Number(node.tagName.slice(1));
          if (nextLevel <= level) break;
        }

        if (
          node !== heading &&
          node.matches('p') &&
          stopLabel.test(normalize(node.querySelector('strong')?.textContent))
        ) {
          break;
        }

        technicalContent.append(node);
        moved = true;
        node = next;
      }
    });

    Array.from(source.querySelectorAll('p')).forEach((label) => {
      if (!label.isConnected || !technicalLabel.test(normalize(label.textContent))) return;

      let node = label;
      while (node) {
        const next = node.nextElementSibling;
        if (
          node !== label &&
          (/^H[1-6]$/.test(node.tagName) ||
            (node.matches('p') && stopLabel.test(normalize(node.querySelector('strong')?.textContent))))
        ) {
          break;
        }

        technicalContent.append(node);
        moved = true;
        node = next;
      }
    });

    if (moved) {
      technicalContent.querySelectorAll('li').forEach((item) => {
        const text = normalize(item.textContent);
        if (!text) return;

        const separator = text.indexOf(':');
        const label = document.createElement('span');
        const value = document.createElement('span');

        item.classList.add('hg-product-data__technical-row');
        item.replaceChildren();

        if (separator > 0) {
          label.className = 'hg-product-data__technical-label';
          label.textContent = text.slice(0, separator).trim();
          value.className = 'hg-product-data__technical-value';
          value.textContent = text.slice(separator + 1).trim();
          item.append(label, value);
        } else {
          item.classList.add('hg-product-data__technical-row--wide');
          value.className = 'hg-product-data__technical-value';
          value.textContent = text;
          item.append(value);
        }
      });

      target.append(technicalContent);
    }
    dataBlock.dataset.hgTechnicalMoved = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => moveTechnicalData());
  } else {
    moveTechnicalData();
  }

  document.addEventListener('shopify:section:load', (event) => moveTechnicalData(event.target));
})();
